import { render, staticRenderFns } from "./case9.vue?vue&type=template&id=b77faf8e&scoped=true&"
import script from "./case9.vue?vue&type=script&lang=js&"
export * from "./case9.vue?vue&type=script&lang=js&"
import style0 from "./case9.vue?vue&type=style&index=0&id=b77faf8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77faf8e",
  null
  
)

export default component.exports